import React, { useEffect, useState, useMemo } from "react";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM } from "../../utils/tokenVerify"
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { Table, Select, Col, Row, Pagination, Input, /* Modal, */ Tooltip } from 'antd';
// import ManageIcon from '../../assets/newlayout/icons/manage_icon.svg';
import { Link } from 'react-router-dom'
import FullLoader from "../../assets/images/full-page-loader.gif"
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import noData from '../../assets/images/data-graph/no-data.svg';
import TableLoader from "../../components/TableLoader";
import addIcon from '../../assets/images/icons/add.svg';
import errorData from '../../assets/images/data-graph/error-data.svg';
import DownalodIcon from '../../assets/newlayout/download_icon.svg';
import EyeIcon from '../../assets/newlayout/eye_new_icon.svg';
// import ReRunIcon from '../../assets/newlayout/icons/re_run_icon.svg';
// import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import CreateNewTask from "./CreateNewTask";
// import ManageConditions from "./ManageConditions";
import ViewReportV2 from "./ViewReportV2";


const formatCreatedAt = (str) => {
    if (!str) return "-";
    // Input: "Tuesday, May 12, 2026 at 3:47:05 AM Pacific Time"
    const match = str.match(/\w+,\s+(\w+)\s+(\d+),\s+(\d+)\s+at\s+(\d+):(\d+):(\d+)\s+(AM|PM)\s+(.*)/);
    if (!match) return str;
    const [, month, day, year, h, m, s, ampm, tzName] = match;
    let hours = parseInt(h);
    if (ampm === 'AM' && hours === 12) hours = 0;
    if (ampm === 'PM' && hours !== 12) hours += 12;
    const time24 = `${String(hours).padStart(2, '0')}:${m}:${s}`;
    const tzMap = {
        'Pacific Time': 'PST', 'Pacific Standard Time': 'PST', 'Pacific Daylight Time': 'PDT',
        'Eastern Time': 'EST', 'Eastern Standard Time': 'EST', 'Eastern Daylight Time': 'EDT',
        'Central Time': 'CST', 'Central Standard Time': 'CST', 'Central Daylight Time': 'CDT',
        'Mountain Time': 'MST', 'Mountain Standard Time': 'MST', 'Mountain Daylight Time': 'MDT',
    };
    const tz = tzMap[tzName.trim()] || tzName.trim();
    const monthAbbr = { January: 'Jan', February: 'Feb', March: 'Mar', April: 'Apr', May: 'May', June: 'Jun', July: 'Jul', August: 'Aug', September: 'Sep', October: 'Oct', November: 'Nov', December: 'Dec' };
    return `${monthAbbr[month] || month} ${day}, ${year} | ${time24} ${tz}`;
};

const getSafeTableColumnWidth = ({
    title,
    requestedWidth,
    sortable = false,
    headerPadding = 32,
    bodyMinWidth = 0,
}) => {
    const normalizedTitle = String(title || "");
    const approximateCharacterWidth = 7.8;
    const sorterWidth = sortable ? 24 : 0;
    const headerMinWidth = Math.ceil(
        normalizedTitle.length * approximateCharacterWidth + headerPadding + sorterWidth
    );

    return Math.max(requestedWidth, headerMinWidth, bodyMinWidth);
};

const getLockedColumnStyle = (width, extraStyles = {}) => ({
    style: {
        width,
        minWidth: width,
        maxWidth: width,
        ...extraStyles,
    }
});

const ACTION_ICON_COUNT = 2;
const ACTION_ICON_SLOT_WIDTH = 28;
const ACTION_ICON_GAP = 2;
const ACTION_CELL_LEFT_PADDING = 8;
const ACTION_CELL_RIGHT_PADDING = 0;
const ACTION_COLUMN_CONTENT_MIN_WIDTH =
    ACTION_CELL_LEFT_PADDING +
    ACTION_CELL_RIGHT_PADDING +
    (ACTION_ICON_COUNT * ACTION_ICON_SLOT_WIDTH) +
    ((ACTION_ICON_COUNT - 1) * ACTION_ICON_GAP);

const Healthcenter = () => {
    const [pageView, setPageView] = useState("table")
    const [selectedRecord, setSelectedRecord] = useState(null)
    const [viewportWidth, setViewportWidth] = useState(() =>
        typeof window !== "undefined" ? window.innerWidth : 1920
    )

    // const [advertiserViewId, setAdvertiserViewId] = useState("")
    // const [advertiserViewName, setAdvertiserViewName] = useState("")
    const tableColumnWidths = useMemo(() => {
        if (viewportWidth <= 1366) {
            return {
                action: 55,
                status: 120,
            };
        }

        if (viewportWidth <= 1450) {
            return {
                action: 52,
                status: 110,
            };
        }
        if (viewportWidth <= 1553) {
            return {
                action: 48,
                status: 110,
            };
        }
        if (viewportWidth <= 1620) {
            return {
                action: 48,
                status: 110,
            };
        }

        if (viewportWidth <= 1750) {
            return {
                action: 40,
                status: 110,
            };
        }

        return {
            action: 40,
            status: 100,
        };
    }, [viewportWidth]);

    const ACTION_COLUMN_WIDTH = getSafeTableColumnWidth({
        title: "Action",
        requestedWidth: tableColumnWidths.action,
        headerPadding: 8,
        bodyMinWidth: ACTION_COLUMN_CONTENT_MIN_WIDTH,
    });
    const STATUS_COLUMN_WIDTH = getSafeTableColumnWidth({
        title: "Status",
        requestedWidth: tableColumnWidths.status,
        sortable: true,
        bodyMinWidth: 100,
    });

    const columnsAll = [
        {
            title: "Action",
            fixed: "left",
            key: "actions",
            width: ACTION_COLUMN_WIDTH,
            onHeaderCell: () => getLockedColumnStyle(ACTION_COLUMN_WIDTH, { padding: '0 0 0 16px' }),
            onCell: () => getLockedColumnStyle(ACTION_COLUMN_WIDTH, { padding: '0 0 0 16px' }),
            render: (_, record) => {
                const canView = record.isView === true || record.isView === 1;
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: `${ACTION_ICON_GAP}px`, flexWrap: 'nowrap' }}>
                        <Tooltip title="Download">
                            <button className='download_icon download_icon_d2' onClick={() => handleDownload(record)}>
                                <img src={DownalodIcon} alt='USP' />
                            </button>
                        </Tooltip>
                        <Tooltip title={canView ? "View Report" : null}>
                            <span style={{ display: 'inline-flex', opacity: canView ? "1" : "0.4" }}>
                                <button
                                    className='download_icon download_icon_d2'
                                    style={{ pointerEvents: canView ? "auto" : "none" }}
                                    onClick={() => handleViewReport(record)}
                                >
                                    <img src={EyeIcon} alt='USP' />
                                </button>
                            </span>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: STATUS_COLUMN_WIDTH,
            onHeaderCell: () => getLockedColumnStyle(STATUS_COLUMN_WIDTH, { padding: '0 12px 0 8px' }),
            onCell: () => getLockedColumnStyle(STATUS_COLUMN_WIDTH, { padding: '0 12px 0 8px' }),
            fixed: "left",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text) => (
                <div style={{ textTransform: "capitalize" }} className={`status_badge_new --new_design_badge ${text === "completed" ? "--completed" : "--processing"}`}>
                    {text}
                </div>
            ),
        },
        {
            title: "Task ID",
            dataIndex: "taskId",
            key: "taskId",
            width: 80,
            onCell: () => ({ style: { padding: '8px 0 8px 16px' } }),
            fixed: "left",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text) => (
                <div className="color_900">
                    {(text === undefined || text === null || text === "" || text === "-") ? <>-</> : <>{text}</>}
                </div>
            ),
        },
        {
            title: "Task Name",
            dataIndex: "taskName",
            key: "taskName",
            width: 250,
            fixed: "left",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => {
                return (
                    <div className="color_900">
                        {text?.length >= 50 ?
                            <Tooltip title={text}>< >{text?.slice(0, 50)}...</></Tooltip> :
                            < >{text}</>}
                    </div>

                )
            },
        },
        // {
        //     title: "Configuration",
        //     dataIndex: "configuration",
        //     key: "configuration",
        //     fixed: "left",
        //     width: 180,
        // },
        // {
        //     title: "Health",
        //     dataIndex: "Health",
        //     key: "Health",
        //     width: 150,
        //     render: (text, record) => (
        //         <div className="health_value">
        //             <p className="color_900 --green">92.7%</p>
        //             {/* --green, --red */}
        //         </div>
        //     ),
        // },
        {
            title: "Platform",
            dataIndex: "platform",
            key: "platform",
            width: 120,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => (
                <div>
                    <div style={{ textTransform: "capitalize" }}>{text}</div>
                </div>
            ),
        },
        {
            title: "Publisher",
            dataIndex: "publisherId",
            key: "publisherId",
            width: 200,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Inventory Type",
            dataIndex: "inventoryType",
            key: "inventoryType",
            width: 120,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => (
                <div>
                    {text === "ctv" ?
                        <div >CTV</div> :
                        <div style={{ textTransform: "capitalize" }}>{text}</div>
                    }
                </div>
            ),
        },
        {
            title: "Zone",
            dataIndex: "zones",
            key: "zones",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 150,
            render: (zones) => {
                if (!zones || zones.length === 0) return <div>-</div>;
                const first = zones[0];
                const remaining = zones.slice(1);
                return (
                    <div className="d_flex align_items_center " style={{ gap: '0.4rem', flexWrap: 'nowrap' }}>
                        <span
                        // className="text_ellipsis" 
                        // style={{ maxWidth: '14rem' }}
                        >
                            {first}
                        </span>
                        {remaining.length > 0 && (
                            <Tooltip title={<div style={{ width: '30rem', maxHeight: '30rem', overflowY: 'auto' }}>{remaining.map((z, i) => <div key={i}>{z}</div>)}</div>} overlayStyle={{ maxWidth: '62rem' }}>
                                <span className="text_blue" style={{ whiteSpace: 'nowrap', cursor: 'pointer', color: "#187B80" }}>, +{remaining.length}</span>
                            </Tooltip>
                        )}
                    </div>
                );
            },
        },
        {
            title: "Created By",
            dataIndex: "email",
            key: "email",
            width: 150,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => (
                <div>
                    <div className="color_900">
                        {(text === undefined || text === null || text === "" || text === "-") ? <>-</> : <>{text}</>}
                    </div>
                    <div className="text_light_css">{formatCreatedAt(record.createdAt)}</div>
                </div>
            ),
        },

    ];



    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)
    const [apiCall, setApiCall] = useState(false)

    const [page, setPage] = useState({ current: 1, pageSize: 50, total: 0 });
    const [sort, setSort] = useState({ name: "", type: "" });
    const [search, setSearch] = useState("")

    const getData = () => {
        setLoading(true)
        const token = Cookies.get("token_xapads_ssp");
        if (!token) return;
        axios
            .get(configData.SERVER_URL + `healthcenter?sort=${sort.name}&order=${sort.type === "ascend" ? "asc" : sort.type === "descend" ? "desc" : ""}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                headers: { "Content-Type": "application/json", "x-access-token": token },
            })
            .then((response) => {
                setData(response.data.data || [])
                if ((response.data.data || []).length > 0) {
                    setPage(prev => ({ ...prev, total: response.data.meta?.total || 0 }))
                }
                setLoading(false)
                setInitialLoad(false)
            })
            .catch(() => {
                setData([])
                setLoading(false)
                setInitialLoad(false)
            });
    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        BlockAM()
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setViewportWidth(window.innerWidth)
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall]);

    useEffect(() => {
        if (!initialLoad && (search.trim().length === 0 || search.trim().length >= 3)) {
            const delayDebounceFn = setTimeout(() => {
                setPage(prev => ({ ...prev, current: 1 }));
                setApiCall(prev => !prev)
            }, 400);
            return () => clearTimeout(delayDebounceFn);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const handleTableChange = (_, __, sorter) => {
        setSort({ name: sorter.field || "", type: sorter.order || "" });
        setApiCall(prev => !prev)
    };

    const columnsWithSortOrder = columnsAll.map(col => ({
        ...col,
        sortOrder: sort.name === col.key ? sort.type : null,
    }));

    const handlePageChange = (pg) => {
        setPage(prev => ({ ...prev, current: pg }));
        setApiCall(prev => !prev)
    };

    const handlePageSizeChange = (sz) => {
        setPage(prev => ({
            ...prev,
            pageSize: sz,
            current: sz * prev.current > prev.total ? 1 : prev.current,
        }));
        setApiCall(prev => !prev)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const handlePageViewEdit = (view, reload) => {
        if (reload === "yes") {
            setApiCall(prev => !prev)
        }
        setPageView(view)
    }

    const handleViewReport = (record) => {
        setSelectedRecord(record);
        setPageView("viewReport");
    };

    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>

                    :
                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };


    //-----------------------download handler ------------------------------
    const handleDownload = (record) => {
        let token = Cookies.get("token_xapads_ssp");
        if (!token || !record?.taskId) return;
        axios
            .get(configData.SERVER_URL + `healthCenter/download?taskId=${record.taskId}`, {
                headers: { "x-access-token": token },
                responseType: "blob",
            })
            .then((res) => {
                const blob = new Blob([res.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `${record.taskId}.xlsx`;
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                window.URL.revokeObjectURL(url);
            })
            .catch(() => { });
    };

    //-----------------------modal related code for re-run ------------------------------
    // eslint-disable-next-line no-unused-vars
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [reRunRecord, setReRunRecord] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [fileError, setFileError] = useState("");
    // eslint-disable-next-line no-unused-vars
    const [reRunLoading, setReRunLoading] = useState(false);

    // eslint-disable-next-line no-unused-vars
    const showModal = (record) => {
        setReRunRecord(record);
        setUploadedFile(null);
        setFileError("");
        setIsModalOpen(true);
    };

    // eslint-disable-next-line no-unused-vars
    const handleCancel = () => {
        setIsModalOpen(false);
        setUploadedFile(null);
        setFileError("");
        setReRunRecord(null);
    };

    // eslint-disable-next-line no-unused-vars
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const allowedExtensions = [".xls", ".xlsx"];
        const fileName = file.name.toLowerCase();
        const isValidType = allowedExtensions.some((ext) => fileName.endsWith(ext));
        if (!isValidType) {
            setFileError("Invalid file type. Only .xls and .xlsx files are allowed.");
            setUploadedFile(null);
            e.target.value = "";
            return;
        }
        const maxSize = 1 * 1024 * 1024; // 1 MB
        if (file.size > maxSize) {
            setFileError("File size must not exceed 1 MB.");
            setUploadedFile(null);
            e.target.value = "";
            return;
        }
        setFileError("");
        setUploadedFile(file);
    };

    // eslint-disable-next-line no-unused-vars
    const handleSaveAndRun = () => {
        if (!uploadedFile) {
            setFileError("Please upload an Excel file before saving.");
            return;
        }
        setReRunLoading(true);
        let token = Cookies.get("token_xapads_ssp");
        const formData = new FormData();
        formData.append("file", uploadedFile);
        formData.append("taskId", reRunRecord?.taskId || "");
        axios
            .post(configData.SERVER_URL + "sample123", formData, {
                headers: {
                    "x-access-token": token,
                },
            })
            .then(() => {
                setReRunLoading(false);
                setIsModalOpen(false);
                setUploadedFile(null);
                setFileError("");
                setReRunRecord(null);
            })
            .catch(() => {
                setReRunLoading(false);
            });
    };



    return (
        <>
            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Health Center
                    </h1>
                </div>

                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="d_flex justify_content_between">
                                    <div className="form_content_block--group">
                                        {!initialLoad &&
                                            <Input
                                                type='text'
                                                className='form_control basic md search_input w_table_search'
                                                placeholder="Search"
                                                value={search}
                                                onChange={(e) => {

                                                    // if (e.target.value.trim().length === 0) {
                                                    //     setLoading(true)
                                                    // }

                                                    setSearch(e.target.value)
                                                    setPage(prev => ({ ...prev, current: 1 }))
                                                }}
                                            />
                                        }
                                    </div>

                                </div>

                                <div className="btn_group">
                                    <button className='btn btn_primary w_fit_content md'
                                        onClick={() => {
                                            setPageView("createNewTask");
                                            // setAdvertiserViewId(record._id)
                                            // setAdvertiserViewName(record.name)
                                        }}
                                    >
                                        <span><img src={addIcon} alt='USP' /> Create New Task</span>
                                    </button>
                                    {/* <button className='btn btn_outline--grey w_fit_content md' style={{ height: '3.6rem' }}
                                        onClick={() => { setPageView("manageConditions") }}
                                    >
                                        <span><img src={ManageIcon} alt='USP' /> Manage Conditions</span>
                                    </button> */}
                                </div>
                            </div>
                        </div>

                        <div className="table_content--box --new_layout_table_design th_fixed_vertical_line table_empty_screen_d2">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <Table
                                    columns={columnsWithSortOrder}
                                    pageSize={100}
                                    // dataSource={data}
                                    dataSource={data}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    scroll={{ x: 'max-content', y: 'calc(100vh - 30.9rem' }} />
                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {page.total > 0 ? `${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items` : `0 items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {pageView === "createNewTask" &&
                <CreateNewTask
                    handlePageViewChange={handlePageViewEdit}

                />
            }

            {/* {pageView === "manageConditions" &&
                <ManageConditions
                    handlePageViewChange={handlePageViewEdit}

                />
            } */}

            {pageView === "viewReport" &&
                <ViewReportV2
                    handlePageViewChange={handlePageViewEdit}
                    rowData={selectedRecord}
                />
            }



            {/* <Modal
                className='custom_modal custom_modal_form_d2'
                // title="Basic Modal"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                // onOk={handleOk}
                maskClosable={false}
                width={800}
                onCancel={handleCancel}
                title={
                    <div className='custom_modal--header'>
                        <div className="d_flex justify_content_between">
                            <h3 className='heading' >
                                <img src={ReRunIcon} alt='USP' /> Re-run
                            </h3>
                        </div>
                    </div>
                }
                footer={false}
            >
                <div className="custom_modal--body p-0">
                    <div className="tab_content--body border-0" style={{ padding: '2.4rem' }}>
                        <div className="container_box--form-container p-0 border-0 mb-0">
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="form_content_block--group hide_caret_after_select_value border-0">
                                        <label className="form_label">Condition Name</label>
                                        <p className="modal_p_text_css">{reRunRecord?.taskName || "-"}</p>
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="form_content_block--group hide_caret_after_select_value border-0">
                                        <label className="form_label">Platform</label>
                                        <p className="modal_p_text_css">{reRunRecord?.platform || "-"}</p>
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="form_content_block--group hide_caret_after_select_value p-0 border-0">
                                        <label className="form_label">Zone</label>
                                        <p className="modal_p_text_css">{reRunRecord?.zone || "-"}</p>
                                    </div>
                                </Col>
                                <Col span={24}>
                                    <div className="form_content_block--group mb-0">
                                        <label className="form_label" htmlFor="fileUploader">Upload a single Excel file containing sample requests *</label>
                                        <label htmlFor='fileUploader' className='ant_upload_drag'>
                                            <p className="upload_drag_icon">
                                                <img src={uploadIcon} alt='USP' />
                                            </p>
                                            <p className="ant_upload_text">
                                                {uploadedFile
                                                    ? <><b className="primary">{uploadedFile.name}</b> &nbsp;({(uploadedFile.size / 1024).toFixed(1)} KB)</>
                                                    : <><b className="primary">Click to upload</b> or drag and drop</>
                                                }
                                            </p>
                                            <p className="ant_upload_hint">Max file size: 1 MB &nbsp;|&nbsp; .xls, .xlsx</p>
                                        </label>
                                        {fileError && <p className="form_error_text" style={{ color: 'red', marginTop: '0.4rem', fontSize: '1.2rem' }}>{fileError}</p>}
                                        <input
                                            className='form_upload d-none'
                                            type="file"
                                            id="fileUploader"
                                            name="fileUploader"
                                            accept=".xls,.xlsx"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className='two_modal_btn'>
                        <div className="btn_group justify-content-end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={handleCancel}>Discard</button>
                            <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSaveAndRun} disabled={reRunLoading}>
                                {reRunLoading ? "Saving..." : "Save & Run"}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal> */}
        </>
    );
};

export default Healthcenter;
